import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '../new-api'

export interface GetChecklistsTemplatesRequest {
  buildingId?: number
  skip?: number
  limit?: number
  search?: string
}

export interface GetChecklistsTemplatesResponse {
  data: {
    id: number
    name: string
  }[]
  total: number
  skip: number
  limit: number
  hasMore: boolean
}

export const getChecklistsTemplatesQueryKey = (data: GetChecklistsTemplatesRequest) => [
  'useGetChecklistsTemplates',
  data,
]

export const getChecklistsTemplates = async (
  data: GetChecklistsTemplatesRequest,
  signal?: AbortSignal,
) => {
  const { buildingId, ...params } = data
  const response = await authAPI.get<GetChecklistsTemplatesResponse>(
    `/checklist-unified/custom/${buildingId}`,
    { params, signal },
  )
  return response.data
}

export const useGetChecklistsTemplates = (data: GetChecklistsTemplatesRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getChecklistsTemplates(data, signal),
    queryKey: getChecklistsTemplatesQueryKey(data),
  })
}
